<template>
  <Suspense>
    <template #default>
      <Relatos v-if="renderComponent" :relato="$route.params.relato" :categoria="$route.params.categoria" ref="variablesRelato"/>
    </template>
    <template #fallback>
      <img src="@/assets/images/Logo_Funifelt_Color.png">
    </template>
  </Suspense>
  
  <!-- Botones para cambiar de relato -->
  <button @click="mostrarMensaje" class="moveButton">&#9664;</button>
  <button @click="mostrarMensaje" class="moveButton">&#9654;</button>

  <!-- Popup de contenido no disponible en esta version -->
  <Popup v-if="TogglePopup" v-on:metodo="cerrarOpcion" :texto="contenidoPopup" />

  <!-- Popup de votacion de like/dislike -->
  <PuntajeRelato v-if="TogglePuntajeRelato" v-on:liked="like" v-on:disliked="dislike" />

</template>

<script>
import Relatos from '@/components/Relato.vue'
import { db } from '@/main.js'
import { collection, query, where, getDocs, setDoc, doc, addDoc, increment, arrayUnion, arrayRemove } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import Popup from '@/components/Popup.vue'
import PuntajeRelato from '@/components/PuntajeRelato.vue'

export default {
  name: 'RelatosView',
  components: {
    Relatos,
    Popup,
    PuntajeRelato
},
  props: {
    relato: { type: String, required: true },
    categoria: { type: String, required: true }
  },
  data () {
    return {
      renderComponent: true,
      relatos: [],
      categoriaActual: this.$route.params.categoria,
      TogglePopup: false,
      contenidoPopup: null,
      
      TogglePuntajeRelato: null,
      ruta: null
    }
  },
  async mounted () {
    // Obtener todos los relatos de la categoria actual
    let categoria = this.categoriaActual
    categoria = categoria.charAt(0).toUpperCase() + categoria.slice(1)

    const coleccionDeRelatos = collection(db, categoria)
    const queryRelatos = await getDocs(coleccionDeRelatos)
    let listaDeRelatos = []
    queryRelatos.forEach((doc) => {
      listaDeRelatos.push(doc.data().Titulo)
    })

    // Guardar la lista de relatos en el data
    this.relatos = listaDeRelatos
  },
  methods: {
    async actualizarComponente () {
      this.renderComponent = false
      await this.$nextTick()
      this.renderComponent = true
    },
    async moverRelato (direccion) {
      let categoria = this.categoriaActual
      categoria = categoria.charAt(0).toUpperCase() + categoria.slice(1)

      let listaDeRelatos = this.relatos
      let relatoActual = this.$route.params.relato

      // Obtener el relato siguiente y anterior
      let siguiente
      let anterior
      for (let i = 0; i < listaDeRelatos.length; i++) {
        if (listaDeRelatos[i] === relatoActual) {
          siguiente = listaDeRelatos[i + 1]
          anterior = listaDeRelatos[i - 1]
          break
        }
      }

      // Si no se encontro el relato anterior o el siguiente, asignar al primero o al ultimo
      if (anterior === undefined) {
        anterior = listaDeRelatos[listaDeRelatos.length - 1]
      }
      if (siguiente === undefined) {
        siguiente = listaDeRelatos[0]
      }
      
      // Determinar si se redirecciona al relato anterior o al siguiente
      if (direccion === '<') {
        await this.$router.push({ name: 'relatos', params: { relato: anterior, categoria: categoria } })
      } else {
        await this.$router.push({ name: 'relatos', params: { relato: siguiente, categoria: categoria } })
      }

      // Actualizar el componente
      this.actualizarComponente()
    },

    // Popup para mostrar que el relato no esta disponible
    mostrarMensaje() {
      if (navigator.language.includes('es')) {
        this.contenidoPopup = 'No disponible en esta versión, <a href="mailto:support@funifelt.com?subject=Solicitud%20de%20acceso%20total%20a%20relatos%20culturales" target="_blank">contáctanos</a\> para obtener más información'
      } else {
        this.contenidoPopup = 'Not available in this version, <a href="mailto:support@funifelt.com?subject=Request%20full%20access%20to%20spanish%20folktales" target="_blank">contact us</a\> for more information'
      }
      this.TogglePopup = true
    },
    cerrarOpcion () {
      this.TogglePopup = false
    },
  
    // Funciones para guardar el voto del usuario
    like () {
      // Guardar el voto en la base de datos
      const docRef = doc(db, 'PuntajesRelatos', this.$refs.variablesRelato.titulo)
      setDoc(docRef, {
        like: {
          counter: increment(1),
          users: arrayUnion(getAuth().currentUser.uid)
        }
      }, { merge: true }) 
      this.$refs.variablesRelato.mostrarVotos = false

      // Redirigir a la ruta original
      this.$router.push(this.ruta)
    },
    dislike () {
      // Guardar el voto en la base de datos
      const docRef = doc(db, 'PuntajesRelatos', this.$refs.variablesRelato.titulo)
      setDoc(docRef, {
        dislike: {
          counter: increment(1),
          users: arrayUnion(getAuth().currentUser.uid)
        }
      }, { merge: true }) 
      this.$refs.variablesRelato.mostrarVotos = false

      // Redirigir a la ruta original
      this.$router.push(this.ruta)
    }
  },

  // Confirmar que el usuario dio like-dislike antes de redireccionarlo
  beforeRouteLeave (to, from, next) {
    if (this.$refs.variablesRelato.mostrarVotos) {
      this.ruta = to
      this.TogglePuntajeRelato = true
      next(false)
    } else {
      next()
    }
  }
}

</script>

<style scoped>
img {
  width: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.moveButton {
  width: 50px;
  height: 50px;
  background-color: #25274F;
  border-radius: 50%;
  border: 0px;
  display: inline-block;
  cursor: pointer;
  color: white;
  text-decoration: none;  
  font-size: 18pt;
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
}
.moveButton:hover {
  background-color: #3F51B5;
}

@media (max-width: 1000px) {
  img {
    width: auto;
    height: 10vh;
  }

  .moveButton:hover {
    background-color: #25274F;
  }
}
</style>
